import React, { Component } from 'react'

// ui
import Pagination from '../../components/uielements/pagination'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../redux/component_select_report/actions'

class Paginate extends Component{
    onShowSizeChange = (current, pageSize) => {
        this.props.changePageSize(pageSize)
    }

    onChange(pageNumber) {
        this.props.changeCurrentPage(pageNumber)
    }

    render(){
        const { total, pageSize, current } = this.props
        return (
            <div className="PaginateContainer">
                <Pagination
                    showSizeChanger
                    onShowSizeChange={(current, pageSize) => this.onShowSizeChange(current, pageSize)}
                    onChange={(pageNumber) => this.onChange(pageNumber)}
                    current={current}
                    pageSizeOptions={['2', '4', '8', '12']}
                    total={total}
                    showQuickJumper
                    pageSize={pageSize}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        total: state.component_select_report.total,
        pageSize: state.component_select_report.pageSize,
        current: state.component_select_report.pageIndex
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changePageSize: pageSize => {
            dispatch(ReportActions.action.changePageSize(pageSize))
        },
        changeCurrentPage: pageNumber => {
            dispatch(ReportActions.action.changeCurrentPage(pageNumber))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Paginate)